<template>
    <div class="controls-footer__wrapper">
        <Cta type="secondary" :displayBlock="true" :largeLabelAtMobile="true" size="lg" label="Done" iconAlignment="left" :route="backToRoute" @updateRoute="handleUpdateRoute"> </Cta>
    </div>
</template>

<script lang="ts">
import Cta from './shared/Cta.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'CtaFooter',
    components: {
        Cta,
    },

    computed: {
        ...mapGetters(['backToRoute']),
    },
    emits: ['update-route'],
    methods: {
        handleUpdateRoute() {
            this.$emit('update-route', this.backToRoute);
        },
    },
    mounted() {},
};
</script>
